import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Sparkles, X, MapPin, Check, ChevronDown, Plus } from 'lucide-react'
import Errortext from '../../Utlis/Errortext'
import {
  CalendarSubEvents,
} from '../../../../Data/event.dto'
import LocationPickerModal from './SetLocationModal'
import { useAppDispatch, useAppSelector } from '../../../../Redux/Hooks'
import { showErrorToast } from '../../Utlis/Toast'
import DeleteIconPNG from '../../../../assets/Icons/deleteIconGradient.svg'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import DatePicker from './DatePicker'
import { addHours, differenceInHours, format, parse } from 'date-fns'
import HourPicker from './HourPicker'
import moment from 'moment'
import { getEventAvailableMembers } from '../../../../Redux/ApiCalls/Dashboard/EventAPI'
import { IMAGE_CDN } from '../../../../config/config'
import {
  ModalOverlay,
  ModalShell,
  ModalHero,
  HeroGlow,
  HeroRow,
  HeroText,
  HeroBadge,
  ModalTitle,
  ModalSubtitle,
  CloseBtn,
  ModalBody,
  FormCard,
  CardLabel,
  FieldInput,
  PrimaryBtn,
  RequiredStar,
  AccentBtn,
  fadeIn,
  SectionTitleRow,
  StepBadge,
  SectionTitleBlock,
  SectionTitle,
  FieldHint,
} from '../../../molecules/Dashboard/EventCalendar/eventModalSharedStyles'

const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`

const InputDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  gap: 8px;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    flex: 1 1 100%;
  }
`

const InputMainDateContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  border-radius: 12px;
  padding: 14px;
  gap: 16px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.06);
  margin-top: 4px;

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  cursor: pointer;

  .MuiFormControl-root {
    width: 100%;
    background: #fff;
    border-radius: 14px;
  }

  .MuiStack-root {
    width: 100%;
    padding-top: 0 !important;
    margin-top: 0 !important;
    overflow: visible !important;
  }

  .MuiOutlinedInput-root {
    border-radius: 14px;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 48px;
    box-sizing: border-box;
  }

  .MuiOutlinedInput-input {
    padding: 12px 14px;
    height: 48px;
    box-sizing: border-box;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(23, 23, 23, 0.1) !important;
    border-radius: 14px;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.4) !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: rgba(201, 77, 170, 0.55) !important;
    border-width: 1px !important;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.12);
  }

  .MuiInputAdornment-root .MuiSvgIcon-root {
    color: #c94daa;
  }
`

const RemoveMemberBtn = styled.button`
  border: none;
  background: rgba(148, 163, 184, 0.2);
  color: #475569;
  font-size: 18px;
  font-weight: 600;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
  &:hover { background: rgba(201, 77, 170, 0.12); color: #c94daa; }
`
// const UsePreviousLocationButton = styled.button`
//   background-color: transparent;
//   font-family: Urbanist, cursive;
//   font-style: normal;
//   font-size: 16px;
//   font-weight: 400;
//   text-align: center;
//   width: 30%;

//   @media (max-width: ${breakpoints.mobile}) {
//     font-size: 0.9rem;
//   }
// `
const SelectLocation = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fafafa;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.3);
    box-shadow: 0 4px 14px rgba(201, 77, 170, 0.08);
  }
`

const LocationTriggerLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
`

const LocationTriggerIcon = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: linear-gradient(
    144.01deg,
    rgba(255, 201, 81, 0.8) 0%,
    rgba(206, 86, 176, 0.8) 100%
  );
`

const LocationTriggerText = styled.span<{ $placeholder?: boolean }>`
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: ${(p) => (p.$placeholder ? 500 : 700)};
  color: ${(p) => (p.$placeholder ? 'rgba(23, 23, 23, 0.4)' : '#171717')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ChevronWrap = styled.span<{ $open?: boolean }>`
  display: inline-flex;
  color: rgba(23, 23, 23, 0.45);
  transform: rotate(${(p) => (p.$open ? 180 : 0)}deg);
  transition: transform 0.15s ease;
`

const SelectionMenu = styled.div<{ menuOpen: boolean }>`
  display: ${({ menuOpen }) => (menuOpen ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
  margin-top: 4px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(23, 23, 23, 0.08);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.12);
  padding: 10px;
  animation: ${({ menuOpen }) => (menuOpen ? fadeIn : 'none')} 0.25s ease-out;
  max-height: 260px;
`

const LocationMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 6px 10px;
`

const LocationMenuHeaderTitle = styled.p`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #171717;
`

const LocationCheck = styled.span<{ $active?: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: ${(p) =>
    p.$active
      ? 'linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%)'
      : 'transparent'};
  border: ${(p) =>
    p.$active ? 'none' : '1.5px solid rgba(23, 23, 23, 0.18)'};
`

const AddNewLocationButton = styled(AccentBtn)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
`
const LocationItemContainer = styled.div`
  max-height: 190px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
`
const LocationItem = styled.button<{ $active?: boolean }>`
  width: 100%;
  border: none;
  cursor: pointer;
  min-height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: ${(p) =>
    p.$active ? 'rgba(201, 77, 170, 0.08)' : 'transparent'};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(201, 77, 170, 0.06);
  }
`

const Location = styled.div`
  flex: 1;
  min-width: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #171717;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 12px;
  }
`

const EmptyLocations = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 24px 12px;
  text-align: center;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.55);
`
interface SubEventModalProps {
  onClose: () => void
  addSubEvent: (subEvent: CalendarSubEvents) => void
  currentSubEvent?: CalendarSubEvents | null
  currentLength: number
  locationList: string[]
  setLocationList: (locationList: string[]) => void
  startInitialDate: string
  endInitialDate: string
}

const SubCalendarEventModal: React.FC<SubEventModalProps> = ({
  onClose,
  addSubEvent,
  currentSubEvent,
  currentLength,
  locationList,
  setLocationList,
  startInitialDate,
  endInitialDate,
}) => {
  const [eventName, setEventName] = useState<string>('')
  const [id, SetId] = useState<number>(0 - (currentLength + 1))
  const [eventLocation, setEventLocation] = useState<string>('')
  const [locationPickerModal, setLocationPickerModal] = useState<boolean>(false)
  const [isLocationListOpen, setIsLocationListOpen] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [eventMembers, setEventMembers] = useState<number[]>([])
  const [selectedMembers, setSelectedMembers] = useState<number[]>([])
  const [selectedHours, setSelectedHours] = useState<{
    value: number
    label: string
  }>()
  const selectionRef = useRef<HTMLSelectElement>(null)

  const selectMenuRef = useRef<HTMLDivElement>(null)
  const [showError, setShowError] = useState(false)
  const [addMemberMenu, setAddMemberMenu] = useState(false)
  const [deleteMember, setDeleteMember] = useState<number[]>([])
  const [subEventMembers, setSubEventMembers] = useState<
    { id: number; member: number }[]
  >([])
  const [duration, setDuration] = useState<number>()
  const { availableMembers: members } = useAppSelector((state) => state.event)
  const { members: totalMemebers } = useAppSelector((state) => state.member)
  // const { availableMembers } = useAppSelector((state) => state.event);
  useEffect(() => {
    if (currentSubEvent) {
      console.log(currentSubEvent)
      setEventName(currentSubEvent.sub_event_name)
      setEventLocation(currentSubEvent.location)
      setStartDate(
        currentSubEvent.start_date +
        'T' +
        currentSubEvent.start_time.substring(0, 5)
      )
      setEndDate(
        currentSubEvent.end_date +
        'T' +
        currentSubEvent.end_time.substring(0, 5)
      )
      const parsedStartDate = parse(
        currentSubEvent.start_date +
        'T' +
        currentSubEvent.start_time.substring(0, 5),
        "yyyy-MM-dd'T'HH:mm",
        new Date()
      )

      const parsedEndDate = parse(
        currentSubEvent.end_date +
        'T' +
        currentSubEvent.end_time.substring(0, 5),
        "yyyy-MM-dd'T'HH:mm",
        new Date()
      )

      if (parsedStartDate && parsedEndDate) {
        const hours = differenceInHours(parsedEndDate, parsedStartDate)
        setSelectedHours({ value: hours, label: `${hours}` })
        setDuration(hours)
      }

      // setEndDate(currentSubEvent.end_date)
      // console.log((new Date(currentSubEvent.start_date + 'T' + currentSubEvent.start_time)).toString())
      SetId(currentSubEvent.id)
      setEventMembers(currentSubEvent.members.map((member) => member.member))
      // if(currentSubEvent.members)
    } else {
      setSelectedHours(undefined)
      setDuration(undefined)
      if (startInitialDate && endInitialDate) {
        setStartDate(startInitialDate)
        setEndDate(endInitialDate)
      } else {
        const currentStartDateTime = new Date()
        setStartDate(
          `${currentStartDateTime.getFullYear()}-${currentStartDateTime.getMonth()}-${currentStartDateTime.getDate()}T${currentStartDateTime.getHours()}:${currentStartDateTime.getMinutes()}`
        )
        setEndDate(
          `${currentStartDateTime.getFullYear()}-${currentStartDateTime.getMonth()}-${currentStartDateTime.getDate()}T${currentStartDateTime.getHours()}:${currentStartDateTime.getMinutes()}`
        )
      }
    }
    return () => {
      setEventName('')
      setEventLocation('')
      setStartDate('')
      setEndDate('')
    }
  }, [currentSubEvent])

  const dispatch = useAppDispatch()

  useEffect(() => {
    const start_date = startDate.split('T')[0]
    const parsedStartDate = moment(startDate)
    const parsedEndDate = moment(endDate)
    if (
      startDate &&
      endDate &&
      duration &&
      parsedStartDate.format('HH:mm:ss') !== parsedEndDate.format('HH:mm:ss')
    ) {
      dispatch(
        getEventAvailableMembers({
          start_date: parsedStartDate.format('YYYY-MM-DD'),
          start_time: parsedStartDate.format('HH:mm:ss'),
          end_time: parsedEndDate.format('HH:mm:ss'),
        })
      )
    }
  }, [startDate, endDate, duration])
  const onChangeData = (name: string, value: string) => {
    if (name === 'event_name' && value.length <= 25) setEventName(value)
    else if (name === 'event_location' && value.length <= 200)
      setEventLocation(value)
    else if (name === 'start_date') {
      setStartDate(formatEnterDate(value))
      if (selectedHours && selectedHours.value) {
        const parsedStartDate = parse(
          formatEnterDate(value),
          "yyyy-MM-dd'T'HH:mm",
          new Date()
        )
        const end = addHours(parsedStartDate, selectedHours.value)
        const formattedEndDateTime = format(end, "yyyy-MM-dd'T'HH:mm")
        setEndDate(formattedEndDateTime)
      }
    }
  }

  const validEventName = (eventNames: string) => {
    if (eventNames.length > 0 && eventNames.length < 40) return true
    else return false
  }

  const setEventDate = (startDateTime: string, endDateTime: string) => {
    const formattedStartDateTime = giveFormattedDateTime(startDateTime)
    const formattedEndDateTime = giveFormattedDateTime(endDateTime)

    const start_time = formattedStartDateTime.formattedTime
    const start_date = formattedStartDateTime.formattedDate
    const end_date = formattedEndDateTime.formattedDate
    const end_time = formattedEndDateTime.formattedTime
    return { start_date, start_time, end_time, end_date }
  }

  const giveFormattedDateTime = (fdate: string) => {
    const date = new Date(fdate)

    // Extract year, month, and day
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0')

    // Format date as yyyy-mm-dd
    const formattedDate = `${year}-${month}-${day}`

    // Extract hours, minutes, and seconds
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    // Format time as HH:MM:SS
    const formattedTime = `${hours}:${minutes}:${seconds}`
    return { formattedDate, formattedTime }
  }

  const validDateTime = (startDateTime: Date, endDateTime: Date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (
      startDateTime.toString().length !== 0 &&
      endDateTime.toString().length !== 0 &&
      startDateTime < endDateTime &&
      startDateTime >= today
    )
      return true
    else return false
  }

  const validateLocation = (location: string) => {
    if (location.length > 0 && location.length < 300) return true
    else return false
  }

  const validDuration = () => {
    return duration != null && duration > 0
  }

  const handleSubmit = () => {
    if (
      !validateLocation(eventLocation) ||
      !validEventName(eventName) ||
      !validDateTime(parseDate(startDate), parseDate(endDate)) ||
      !validDuration()
    ) {
      setShowError(true)
    } else {
      let { start_date, start_time, end_date, end_time } = setEventDate(
        parseDate(startDate).toString(),
        parseDate(endDate).toString()
      )
      console.log(
        setEventDate(
          parseDate(startDate).toString(),
          parseDate(endDate).toString()
        )
      )

      addSubEvent({
        sub_event_name: eventName,
        location: eventLocation,
        start_date: start_date,
        start_time: start_time,
        end_date: end_date,
        end_time: end_time,
        // sub_event_coordinates: "test coordinates",
        // for not making same id to new event with existing
        id: id,
        members: [
          ...selectedMembers.map((member) => {
            return { member: member, id: member }
          }),
          ...eventMembers.map((member) => {
            return { member: member, id: member }
          }),
        ],
      })
    }
  }

  const setPickLocation = (loc: string) => {
    setEventLocation(loc)
  }
  const setLocation = (loc: string) => {
    setLocationList([...locationList, loc])
    setLocationPickerModal(false)
    setIsLocationListOpen(false)
    setEventLocation(loc)
  }

  const handleMember = (id: number) => {
    if (deleteMember.includes(id)) {
      setDeleteMember((pre) => pre.filter((member) => member !== id))
      eventMembers.push(id)
    } else {
      if (selectedMembers.includes(id)) {
        setSelectedMembers((pre) => pre.filter((val) => val !== id))
      } else {
        setSelectedMembers((pre) => [...pre, id])
      }
    }
  }
  const handleButtonClick = (buttonAction: () => void) => {
    setAddMemberMenu(false)
    buttonAction()
  }
  const handleDeleteMember = (id: number) => {
    if (!deleteMember.includes(id) && eventMembers.includes(id)) {
      setDeleteMember([...deleteMember, id])
      setEventMembers((pre) => pre.filter((member) => member !== id))
    }
  }

  const formatEnterDate = (dateString: string): string => {
    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
  const parseDate = (formattedDate: string): Date => {
    // Expected format: YYYY-MM-DDTHH:MM
    const [datePart, timePart] = formattedDate.split('T')
    const [year, month, day] = datePart.split('-').map(Number)
    const [hours, minutes] = timePart.split(':').map(Number)

    // JavaScript Date object months are zero-based, so we need to subtract 1 from the month
    return new Date(year, month - 1, day, hours, minutes)
  }

  const onChangeEventHour = (hour: number) => {
    setDuration(hour)
    const parsedStartDate = parse(startDate, "yyyy-MM-dd'T'HH:mm", new Date())
    setSelectedHours({
      label: `${hour}`,
      value: hour,
    })
    if (parsedStartDate) {
      const end = addHours(parsedStartDate, hour)
      const formattedEndDateTime = format(end, "yyyy-MM-dd'T'HH:mm")
      setEndDate(formattedEndDateTime)
    }
  }

  return (
    <ModalOverlay
      onClick={() => {
        // First outside click should only dismiss an open date picker, not the whole modal
        if (document.querySelector('.MuiPickersPopper-root')) return
        onClose()
      }}
    >
      <ModalShell onClick={(e) => e.stopPropagation()}>
        {locationPickerModal && (
          <LocationPickerModal
            onClose={() => setLocationPickerModal(false)}
            isOpen={locationPickerModal}
            onSelect={setLocation}
          />
        )}
        <ModalHero>
          <HeroGlow />
          <HeroRow>
            <HeroText>
              <HeroBadge>
                <Sparkles size={10} />
                Day schedule
              </HeroBadge>
              <ModalTitle>
                {currentSubEvent ? 'Edit day schedule' : 'Add day schedule'}
              </ModalTitle>
              <ModalSubtitle>
                Fill in this shoot day&apos;s name, timing, venue, and crew. Required fields are marked with *.
              </ModalSubtitle>
            </HeroText>
            <CloseBtn type="button" onClick={onClose}>
              <X size={18} />
            </CloseBtn>
          </HeroRow>
        </ModalHero>
        <ModalBody>
          <FormCard>
            <SectionTitleRow>
              <StepBadge>1</StepBadge>
              <SectionTitleBlock>
                <SectionTitle>
                  Day name <RequiredStar>*</RequiredStar>
                </SectionTitle>
                <FieldHint>
                  What is this day called? Examples: Engagement, Haldi, Wedding day, Reception.
                </FieldHint>
              </SectionTitleBlock>
            </SectionTitleRow>
            <InputContainer>
              <FieldInput
                type="text"
                id="name"
                placeholder="e.g. Wedding day"
                name="name"
                onChange={(e) => onChangeData('event_name', e.target.value)}
                value={eventName}
              />
            </InputContainer>
            <Errortext
              show={showError && !validEventName(eventName)}
              message={'Please enter a day name (max 25 characters).'}
            />
          </FormCard>

          <FormCard>
            <SectionTitleRow>
              <StepBadge>2</StepBadge>
              <SectionTitleBlock>
                <SectionTitle>
                  When does it happen? <RequiredStar>*</RequiredStar>
                </SectionTitle>
                <FieldHint>
                  Pick the start date &amp; time, then choose how many hours the shoot lasts. End time is calculated for you.
                </FieldHint>
              </SectionTitleBlock>
            </SectionTitleRow>
            <InputMainDateContainer>
              <InputDateContainer>
                <CardLabel htmlFor="event_date">Start date &amp; time</CardLabel>
                <DateContainer>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label=""
                      value={startDate}
                      onChangeData={(e) => onChangeData('start_date', e)}
                    />
                  </LocalizationProvider>
                </DateContainer>
              </InputDateContainer>
              <InputDateContainer>
                <CardLabel htmlFor="duration">Duration (hours)</CardLabel>
                <HourPicker
                  value={selectedHours}
                  onChange={(hour) => onChangeEventHour(hour)}
                />
                <Errortext
                  show={showError && !validDuration()}
                  message={'Please select how many hours this day lasts.'}
                />
              </InputDateContainer>
            </InputMainDateContainer>
            <Errortext
              show={
                showError &&
                !validDateTime(new Date(startDate), new Date(endDate))
              }
              message={'Please choose a valid start date that is today or later.'}
            />
          </FormCard>

          <FormCard>
            <SectionTitleRow>
              <StepBadge>3</StepBadge>
              <SectionTitleBlock>
                <SectionTitle>
                  Where is it? <RequiredStar>*</RequiredStar>
                </SectionTitle>
                <FieldHint>
                  Select a saved venue or add a new location so your team knows where to go.
                </FieldHint>
              </SectionTitleBlock>
            </SectionTitleRow>
            <InputContainer>
              <SelectLocation
                type="button"
                onClick={() => setIsLocationListOpen((pre) => !pre)}
              >
                <LocationTriggerLeft>
                  <LocationTriggerIcon>
                    <MapPin size={15} />
                  </LocationTriggerIcon>
                  <LocationTriggerText $placeholder={!eventLocation}>
                    {eventLocation || 'Tap to choose location'}
                  </LocationTriggerText>
                </LocationTriggerLeft>
                <ChevronWrap $open={isLocationListOpen}>
                  <ChevronDown size={16} />
                </ChevronWrap>
              </SelectLocation>
            </InputContainer>
            <Errortext
              show={showError && !validateLocation(eventLocation)}
              message={'Please select or add a location for this day.'}
            />
            {isLocationListOpen && (
              <SelectionMenu menuOpen={isLocationListOpen}>
                <LocationMenuHeader>
                  <LocationMenuHeaderTitle>Saved locations</LocationMenuHeaderTitle>
                  <AddNewLocationButton
                    type="button"
                    onClick={() => setLocationPickerModal(true)}
                  >
                    <Plus size={13} />
                    Add New
                  </AddNewLocationButton>
                </LocationMenuHeader>
                <LocationItemContainer>
                  {locationList.length > 0 ? (
                    locationList.map((location) => {
                      const active =
                        location.toLowerCase() === eventLocation.toLowerCase()
                      return (
                        <LocationItem
                          key={location}
                          type="button"
                          $active={active}
                          onClick={() => {
                            setPickLocation(location)
                            setIsLocationListOpen(false)
                          }}
                        >
                          <Location>{location}</Location>
                          <LocationCheck $active={active}>
                            {active ? <Check size={13} strokeWidth={3} /> : null}
                          </LocationCheck>
                        </LocationItem>
                      )
                    })
                  ) : (
                    <EmptyLocations>
                      <MapPin size={18} />
                      No locations yet. Tap Add New to create one.
                    </EmptyLocations>
                  )}
                </LocationItemContainer>
              </SelectionMenu>
            )}
          </FormCard>

          <MembersFormCard $elevated={addMemberMenu}>
            <SectionTitleRow>
              <StepBadge>4</StepBadge>
              <SectionTitleBlock>
                <SectionTitle>
                  Who is working this day?
                  <MemberCountHint>
                    {' '}
                    ({selectedMembers.length + eventMembers.length})
                  </MemberCountHint>
                </SectionTitle>
                <FieldHint>
                  Optional — assign photographers or staff available for this time slot. Only free members are listed.
                </FieldHint>
              </SectionTitleBlock>
            </SectionTitleRow>
            <MemberSelecetionConatiner>
              <SelectedMemberConatiner>
                {selectedMembers.length === 0 && eventMembers.length === 0 ? (
                  <EmptyMembersHint>
                    No crew assigned yet. Add members below if you already know who is covering this day.
                  </EmptyMembersHint>
                ) : (
                  <SelectedMembersList>
                    {currentSubEvent &&
                      totalMemebers &&
                      eventMembers.length > 0 &&
                      totalMemebers?.map(
                        (member) =>
                          eventMembers.includes(parseInt(member.id)) && (
                            <SelectedMemberDataConatiner key={`ev-${member.id}`}>
                              <SelectedMemberData>
                                <MemberData>
                                  <MeberProfileImage
                                    src={`${IMAGE_CDN}/${member.profile_image}`}
                                  />
                                  <MemberText>
                                    <MemberName>{member.name}</MemberName>
                                    <MemberRole>{member.job_type}</MemberRole>
                                  </MemberText>
                                </MemberData>
                                <DeleteIcon
                                  onClick={(e) =>
                                    handleButtonClick(() =>
                                      handleDeleteMember(parseInt(member.id))
                                    )
                                  }
                                  src={DeleteIconPNG}
                                />
                              </SelectedMemberData>
                            </SelectedMemberDataConatiner>
                          )
                      )}
                    {members &&
                      members.map(
                        (member) =>
                          selectedMembers.includes(parseInt(member.id)) && (
                            <SelectedMemberDataConatiner key={`sel-${member.id}`}>
                              <SelectedMemberData>
                                <MemberData>
                                  <MeberProfileImage
                                    src={`${IMAGE_CDN}/${member.profile_image}`}
                                  />
                                  <MemberText>
                                    <MemberName>{member.name}</MemberName>
                                    <MemberRole>{member.job_type}</MemberRole>
                                  </MemberText>
                                </MemberData>
                                <RemoveMemberBtn
                                  type="button"
                                  onClick={() =>
                                    handleMember(parseInt(member.id))
                                  }
                                >
                                  &times;
                                </RemoveMemberBtn>
                              </SelectedMemberData>
                            </SelectedMemberDataConatiner>
                          )
                      )}
                  </SelectedMembersList>
                )}
              </SelectedMemberConatiner>
              <SelectionMenuListConatiner>
                <AddMemberTrigger
                  onClick={() => {
                    members.length === 0
                      ? showErrorToast(
                        'Currently, no members are available at this time slots.'
                      )
                      : setAddMemberMenu((pre) => !pre)
                  }}
                >
                  <AddMemberLabel>Tap to add available members (optional)</AddMemberLabel>
                  <SelectMemberLabel
                    ref={selectionRef}
                    defaultValue={'Add Member'}
                  />
                </AddMemberTrigger>
                {addMemberMenu && (
                  <AddMemberListConatiner ref={selectMenuRef}>
                    <MemberList>
                      {members &&
                        members.map(
                          (member) =>
                            !eventMembers.includes(parseInt(member.id)) && (
                              <MemberListItem htmlFor={`member${member.id}`} key={member.id}>
                                <MemberData>
                                  <MeberProfileImage
                                    src={`${IMAGE_CDN}/${member.profile_image}`}
                                  />
                                  <MemberText>
                                    <MemberName>{member.name}</MemberName>
                                    <MemberRole>{member.job_type}</MemberRole>
                                  </MemberText>
                                </MemberData>
                                <MemberSelectButton
                                  id={`member${member.id}`}
                                  type="checkbox"
                                  onChange={() => {
                                    handleMember(parseInt(member.id))
                                  }}
                                  checked={selectedMembers.includes(
                                    parseInt(member.id)
                                  )}
                                ></MemberSelectButton>
                              </MemberListItem>
                            )
                        )}
                    </MemberList>
                  </AddMemberListConatiner>
                )}
              </SelectionMenuListConatiner>
            </MemberSelecetionConatiner>
          </MembersFormCard>

          <PrimaryBtn type="button" onClick={() => handleSubmit()}>
            {currentSubEvent ? 'Save day schedule' : 'Add day schedule'}
          </PrimaryBtn>
        </ModalBody>
      </ModalShell>
    </ModalOverlay>
  )
}

export default SubCalendarEventModal

const MembersFormCard = styled(FormCard)<{ $elevated?: boolean }>`
  position: relative;
  overflow: visible;
  z-index: ${(p) => (p.$elevated ? 30 : 1)};
`

const MemberSelecetionConatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
`
const MemberCountHint = styled.span`
  font-weight: 600;
  color: rgba(23, 23, 23, 0.45);
`
const EmptyMembersHint = styled.p`
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid rgba(23, 23, 23, 0.06);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: rgba(23, 23, 23, 0.55);
`
const SelectedMemberConatiner = styled.div``
const SelectionMenuListConatiner = styled.div`
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 20;
`
const AddMemberTrigger = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fafafa;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.3);
    box-shadow: 0 4px 14px rgba(201, 77, 170, 0.08);
  }
`
const SelectMemberHeading = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
  color: #171717;
  margin: 0;
`
const MemberMenuConatriner = styled.div`
  position: relative;
  width: 100%;
`
const AddMemberListConatiner = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  right: 0;
  width: 100%;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  z-index: 50;
  background: white;
  border-radius: 14px;
  border: 1px solid rgba(23, 23, 23, 0.08);
  overflow: hidden;
  max-height: 220px;
`

const SelectMemberHeadingConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const MemberList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 172px;
  overflow: auto;
  padding: 6px 8px;
`
const MemberListItem = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  &:hover { background: rgba(201, 77, 170, 0.06); }
`
const MemberText = styled.div`
  margin-left: 10px;
`
const MemberSelectButton = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
  border: 2px solid transparent;
  background: 
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(133.16deg, #FFC951 -4.52%, #CE56B0 107.63%) border-box;
  border-radius: 5px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;

  &:checked {
    width: 21px;
    background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
    border: 2px solid transparent;
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: -1px;
    left: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`
const MeberProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`

const SelectedMembersList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
`
const SelectedMemberDataConatiner = styled.div`
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 14px;
  padding: 12px;
  background: #fafafa;
`
const SelectedMemberData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

const SelectMemberLabel = styled.select`
  display: none;
`
const AddMemberLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
`

const MemberData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  min-width: 0;
`
const MemberName = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  color: #171717;
`
const MemberRole = styled.p`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  margin: 0;
  color: rgba(23, 23, 23, 0.5);
`

const DeleteIcon = styled.img`
  height: 25px;
  width: 25px;
  cursor: pointer;
`
